// src/api.js
// All calls to the Render FastAPI backend go through here.

const API = process.env.REACT_APP_API_URL || 'http://localhost:8001';
const ADMIN_KEY = process.env.REACT_APP_ADMIN_KEY || '';

const headers = () => ({
  'Content-Type': 'application/json',
  'x-admin-key': ADMIN_KEY,
});

async function request(method, path, body) {
  const res = await fetch(`${API}${path}`, {
    method,
    headers: headers(),
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: res.statusText }));
    throw new Error(err.detail || `HTTP ${res.status}`);
  }
  return res.json();
}

export const api = {
  // Health
  health:       () => request('GET', '/api/implants/health'),

  // Queue
  getQueue:     (status = 'needs_review') => request('GET', `/api/implants/admin/queue?status=${status}`),
  getCounts:    () => request('GET', '/api/implants/admin/queue/counts'),

  // Actions
  approve:      (kNumber, body) => request('POST', `/api/implants/admin/approve/${kNumber}`, body),
  reject:       (kNumber) => request('POST', `/api/implants/admin/reject/${kNumber}`),

  // Live DB
  listImplants: (manufacturer) => request('GET', `/api/implants/admin/implants${manufacturer ? `?manufacturer=${manufacturer}` : ''}`),
  addImplant:   (body) => request('POST', '/api/implants/admin/add', body),
  deleteImplant:(name) => request('DELETE', `/api/implants/admin/implants/${encodeURIComponent(name)}`),

  // Schema
  getSchema:    () => request('GET', '/api/implants/features'),
};
